<div class="d-flex align-items-center justify-content-center">
  <div class="wrapper">
    <img src="../../../assets/img/logo.png" alt="3u-logo">
    <p>{{'welcome-to' | translateWithFallback}} 3u Cloud!</p>

    <span>APP version: {{feVersion}}</span> <br>
    <span>API version: {{apiVersion}}</span> <br><br>
    
    <span>{{'copyright' | translateWithFallback}} © 2020-{{appInfo.currentYear}} {{appInfo.issuer}}. <br/> {{'trademarks' | translateWithFallback}}</span>
  </div>
</div>
